import IdentityStore from 'stores/IdentityStore';
import AuthorStore from 'stores/AuthorStore';
import I18nStore from 'stores/I18nStore';

class AuthorName {
  static localizedAuthorName() {
    const locale = I18nStore.getState().currentLocale;
    /* Return a localized author name only if the locale
    is defined and a localizedName exists for that locale */
    if (locale) {
      const currentAmazonAuthorID = IdentityStore
        .getState().currentIdentity.amazonAuthorId;
      // TODO: Get updated author names from Iridium as seen in https://issues.amazon.com/issues/AUTHOR-4537
      const localizedName = AuthorStore.getState()
        .authors[currentAmazonAuthorID].localizedNames[locale];
      if (localizedName) {
        return localizedName;
      }
    }
    return IdentityStore.getState().currentIdentity.claimedAuthorName || '';
  }
}

export default AuthorName;
